export const Constants = {
  oversight: 'Proto Oversight',
  oversight_title_tooltip: 'Monitore sessões e acesso delegado',
  notifications: 'Notificações',
  notifications_open: 'Abrir notificações',
  notifications_close: 'Fechar notificações',
  notifications_search: 'Buscar por cliente ou data...',
  notifications_client: 'Cliente:',
  notifications_today: 'Hoje',
  notifications_yesterday: 'Ontem',
  notifications_empty: 'Nenhuma notificação encontrada.',
  notifications_load_more: 'Carregar mais',
  notifications_mark_as_read: 'Marcar como lida',
};
